import axios from 'axios'
import { sha256 } from 'js-sha256';
import base64url from "base64url";
import config from '@/config'

const API_URL = config.API_URL

export default {
  state: {},
  mutations: {},
  actions: {
    async logout(ctx){
      if(localStorage.getItem("weltumKey")) {
        const key = localStorage.getItem("weltumKey")
        const Time = Date.now().toString()
        const test = sha256.hmac(key, Time);
        const Hmac = base64url(test)
        await axios.delete(
          `${API_URL}/api/rest/receipt/delete_session?secret_key=${key}`,
          {
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
              'X-Hmac': Hmac,
              'X-Time': Time,
            }
          },
        ).then((/*response*/) => {
          localStorage.removeItem("weltumAuth")
          localStorage.removeItem("weltumKey")
          localStorage.removeItem("weltumTimeAuth")
          localStorage.removeItem("weltumtokenTimeAlive")
          localStorage.removeItem("weltum_user_fio")
          localStorage.removeItem("weltum_user_tel")
          localStorage.removeItem("weltum_user_mail")
          localStorage.removeItem("weltumPass")
          localStorage.removeItem("weltumLastUrl")
        })
      }else{
        localStorage.removeItem("weltumAuth")
        localStorage.removeItem("weltumKey")
        localStorage.removeItem("weltumTimeAuth")
        localStorage.removeItem("weltumtokenTimeAlive")
        localStorage.removeItem("weltum_user_fio")
        localStorage.removeItem("weltum_user_tel")
        localStorage.removeItem("weltum_user_mail")
        localStorage.removeItem("weltumPass")
        localStorage.removeItem("weltumLastUrl")
      }
      ctx.commit('setAuth', false)
    }
  },
  getters:{},
}